module.exports = __webpack_public_path__ + "img/customers_tubeLeft.16173fab.png";